export const fullStatChannels = [108, 1367];
